import { adminScopeParams as scopeParams } from "./deploymentScope";

/** Shared API brand tag (matches `Tawan Spa/server` booking brand). */
export const APP_BRAND =
  String(process.env.REACT_APP_BRAND || "dr-hoffmann").trim().toLowerCase() ||
  "dr-hoffmann";

/** Default admin dashboard scope: all brands (Dr. Hoffmann + Tawan Spa). */
export const ADMIN_BRAND_DEFAULT = "all";

/** Default Ort filter for admin booking lists. */
export const ADMIN_ORT_DEFAULT = "all";

export const adminBrandParams = (extra = {}) => {
  const { brand = ADMIN_BRAND_DEFAULT, ort = ADMIN_ORT_DEFAULT, ...rest } = extra;
  return scopeParams({
    brand,
    ...(ort && ort !== ADMIN_ORT_DEFAULT ? { ort } : {}),
    ...rest,
  });
};
